export function inArray(search: any, array: any, strict: boolean = false): boolean {
    if (!(array instanceof Array)) {
        return false
    }

    for (let compareValue of array) {
        if (this.strict && search === compareValue) {
            return true
        } else if (!this.strict && search == compareValue) {
            return true
        }
    }

    return false
}
